import { render, staticRenderFns } from "./bookkeepingOrderList.vue?vue&type=template&id=3605aaf1"
import script from "./bookkeepingOrderList.vue?vue&type=script&lang=js"
export * from "./bookkeepingOrderList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports